var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.screenWidth > 992)?_c('FundInfo'):_c('fund-info-phone'),_c('FundTable'),_c('FundQuestion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }